
export interface LoginResponseDto {
  /**
   * 
   * @type {number}
   * @memberof LoginResponseDto
   */
  'id'?: number;
  /**
   * 
   * @type {MfaWay}
   * @memberof LoginResponseDto
   */
  'mfaWay'?: MfaWay;
  /**
   * 
   * @type {string}
   * @memberof LoginResponseDto
   */
  'email'?: string | null;
  /**
   * 
   * @type {string}
   * @memberof LoginResponseDto
   */
  'phoneTail'?: string | null;
  /**
   * 
   * @type {number}
   * @memberof LoginResponseDto
   */
  'vCodeId'?: number;
}

export enum MfaWay {
  Email = 0,
  Phone = 1
}

export interface UserSettings {
  id_token: string;
  session_state: string;
  access_token: string;
  refresh_token: string;
  token_type: string;
  scope: string;
  profile: any;
  expires_at: number;
  state: any;
}
